import { useI18n as _useI18n } from 'vue-i18n'

export function useI18n() {
  return _useI18n({ useScope: 'global' })
}

